// src/utils/api.js
export const fetchSites = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get-all-sites`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const data = await response.json();
  return Array.isArray(data) ? data : data.sites || [];
};

export const addSite = async (token, siteData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/addsite`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(siteData),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
};

export const fetchBays = async (token, siteId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get-all-bays?site_id=${siteId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const data = await response.json();
  // Normalize selected_days to ensure it's an array
  const normalizedBays = (Array.isArray(data.bays) ? data.bays : []).map(bay => ({
    ...bay,
    selected_days: typeof bay.selected_days === "string"
      ? JSON.parse(bay.selected_days.replace(/'/g, '"')) // Handle quotes if needed
      : Array.isArray(bay.selected_days) ? bay.selected_days : [],
  }));
  return normalizedBays;
};

export const addBay = async (token, bayData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/addbay`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(bayData),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
};

export const updateBays = async (token, bayData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/update-bays`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(bayData),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
};

export const updateSite = async (token, siteData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/update-site`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(siteData),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
};

export const fetchCustomers = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get-customers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
};

export const updateCustomer = async (token, customerData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/update-customers`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(customerData),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
};